import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, call, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';
import { uploadFileToBlob } from '@storage/azure-storage-blob';
import { BlobUploadCommonResponse } from '@azure/storage-blob';

function* generateToken(action: actionsInterfaces.IGetTokeAction) {
  let token: string;
  try {
      token = yield select(selectors.auth.getAuthToken);
      const response: AxiosResponse<any> = yield axios.get(`${host}storage-token`,{headers: {Authorization: token}})
      if (response.status >= 200 && response.status <= 300) {
        yield put(actions.storage.setToken(response.data.token));
        if (action.callback) { action.callback(response.data); }  
      } else if (response.status === 400 || response.status === 401 || response.status === 403) {
        const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
        if (userManager) yield userManager.signoutRedirect();
        yield put(actions.auth.setAuth(undefined, undefined, undefined));
        if (action.callback) { action.callback(undefined, response); }  
      } else {
        yield put(serverError(response.data));
        if (action.callback) { action.callback(undefined, response); }  
      }  
      
    } catch (e) {
      yield put(serverError(e));
      if (action.callback) { action.callback(undefined, e); }    
    }
}

function* uploadFile(action: actionsInterfaces.IUploadFileAction) {
  let token = action.token;
  try {
    if (!token) {
      yield call(generateToken, action);
      token = yield select(selectors.storage.getToken);
    }
    const response: BlobUploadCommonResponse = yield uploadFileToBlob(action.file.file, token!, action.file.container);
    if (action.callback) action.callback(response, undefined);
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) action.callback(undefined, e);
  }
}

function* duplicateFile(action: actionsInterfaces.IDuplicateFileAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}storage-copyblob`, action.duplicateFileData, {headers: { Authorization: token }});
    if (action.callback) action.callback(response, undefined);
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) action.callback(undefined, e);
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.GET_TOKEN, generateToken),
    takeEvery(actionsTypes.UPLOAD_FILE, uploadFile),
    takeEvery(actionsTypes.DUPLICATE_FILE, duplicateFile)
  ])
}

